module.exports = __webpack_public_path__ + "img/img_1(shared).5ad04a97.png";